import {Tooltip} from "@progress/kendo-react-tooltip";
import {mainMessages, removeProductKey} from "../../../assets/text/MultilingualText";
import {DeleteIcon} from "../../common/icons";
import React, {useContext} from "react";
import {useLocalization} from "@progress/kendo-react-intl";
import UserContext from "../../common/UserContext";
import axios from "axios";
import config from "../../../config";
import {AssignedProductContext, GeneralContext, SelectedProductContext} from "../FSARequestLicenseContext";

export const DeleteCell = props => {
    const {
        siteLanguageDefault,
        accessToken
    } = useContext(UserContext);

    const {
        setIsLoading,
        headerInfo,
        uniqueID,
        parentUniqueID,
        setHeaderInfo,
        onePerHostKey,
    } = useContext(GeneralContext);

    const {
        selectedProducts,
        setSelectedProducts,
    } = useContext(SelectedProductContext);

    const {
        assignedProducts,
        setAssignedProducts,
        unsavedAssignedChanges,
        setUnsavedAssignedChanges,
    } = useContext(AssignedProductContext);

    const {
        dataItem,
        setShowGenericError
    } = props

    const localization = useLocalization();

    //delete selected and assigned products
    const saveDelete = () => {
        let products = []
        const deleteID =dataItem[uniqueID]
        const parentID = dataItem[parentUniqueID]

        products.push({
            'cart_id': deleteID,
            'status': dataItem.status
        })
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + accessToken
        };
        setIsLoading(true);

        let body = {
            module: "FSA",
            sub_module: "CART",
            action: "DELETE",
            input_json: {
                fsa_id: headerInfo.fsa_id,
                products: products
            }
        }

        axios.delete(
            config.fsa_request_license.CART,
            {headers: headers, data: body}
        )
            .then((response) => {
                if (response.status === 200) {
                    let data = response.data
                    setHeaderInfo(data['header_info'])

                    //delete from assigned products
                    let newAssignedProducts = assignedProducts.map(host => {
                        let hostProducts = host['products']
                        const index = hostProducts.findIndex(item => item[uniqueID] === deleteID)
                        if (index > -1) {
                            hostProducts.splice(index, 1)
                        }
                        return host
                    })

                    newAssignedProducts = newAssignedProducts.filter(host => host.products.length > 0)
                    setAssignedProducts(newAssignedProducts)

                    //add back qty to selected product's unassigned qty
                    const parentProduct = selectedProducts.find(item => item[uniqueID] === parentID)
                    parentProduct.unassigned_quantity += dataItem.assign_quantity
                    parentProduct.saved_assigned_quantity -= dataItem.assign_quantity
                    parentProduct.assign_quantity = parentProduct[onePerHostKey] === "Y" ? 1
                        : parentProduct.unassigned_quantity === 1 ? 1
                            : null;
                    setSelectedProducts([...selectedProducts])

                    //remove product from unsaved changes if it exists
                    unsavedAssignedChanges.delete(deleteID)
                    setUnsavedAssignedChanges(unsavedAssignedChanges)
                }
            })
            .catch((error) => {
                console.log("ERROR: Failed to delete product", error);
                setShowGenericError(true)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return (
        <td>
            <Tooltip
                anchorElement="target"
                showCallout={true}
                parentTitle={true}
                openDelay={0}
                position="top"
            >
                <div
                    title={localization.toLanguageString(removeProductKey, mainMessages[siteLanguageDefault][removeProductKey])}
                    onClick={saveDelete}
                >
                    <DeleteIcon
                        className={'ksm-grid-icon'}
                    />
                </div>
            </Tooltip>
        </td>
    )
}
